/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dont_Have_An_AccountInputs */

const en_dont_have_an_account = /** @type {(inputs: Dont_Have_An_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don't have an account?`)
};

const es_dont_have_an_account = /** @type {(inputs: Dont_Have_An_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿No tienes una cuenta?`)
};

const fr_dont_have_an_account = /** @type {(inputs: Dont_Have_An_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous n'avez pas de compte ?`)
};

const de_dont_have_an_account = /** @type {(inputs: Dont_Have_An_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast noch kein Konto?`)
};

const ja_dont_have_an_account = /** @type {(inputs: Dont_Have_An_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウントをお持ちでないですか？`)
};

const zh_dont_have_an_account = /** @type {(inputs: Dont_Have_An_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`还没有账号？`)
};

const ar_dont_have_an_account = /** @type {(inputs: Dont_Have_An_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ليس لديك حساب؟`)
};

const id_dont_have_an_account = /** @type {(inputs: Dont_Have_An_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum punya akun?`)
};

const it_dont_have_an_account = /** @type {(inputs: Dont_Have_An_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non hai un account?`)
};

const ru_dont_have_an_account = /** @type {(inputs: Dont_Have_An_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет аккаунта?`)
};

const pt_dont_have_an_account = /** @type {(inputs: Dont_Have_An_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não tem uma conta?`)
};

const ko_dont_have_an_account = /** @type {(inputs: Dont_Have_An_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계정이 없으신가요?`)
};

/**
* | output |
* | --- |
* | "Don't have an account?" |
*
* @param {Dont_Have_An_AccountInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const dont_have_an_account = /** @type {((inputs?: Dont_Have_An_AccountInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dont_Have_An_AccountInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dont_have_an_account(inputs)
	if (locale === "es") return es_dont_have_an_account(inputs)
	if (locale === "fr") return fr_dont_have_an_account(inputs)
	if (locale === "de") return de_dont_have_an_account(inputs)
	if (locale === "ja") return ja_dont_have_an_account(inputs)
	if (locale === "zh") return zh_dont_have_an_account(inputs)
	if (locale === "ar") return ar_dont_have_an_account(inputs)
	if (locale === "id") return id_dont_have_an_account(inputs)
	if (locale === "it") return it_dont_have_an_account(inputs)
	if (locale === "ru") return ru_dont_have_an_account(inputs)
	if (locale === "pt") return pt_dont_have_an_account(inputs)
	return ko_dont_have_an_account(inputs)
});